import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';
import { PortalTarget } from 'portal-vue';
import { datadogRum } from '@datadog/browser-rum';

import type {
  Policy,
} from '@white-label-types/parking-booking';
import type { Item as ReceiptItem } from '@white-label-types/parking-checkout';
import { PRODUCT_TYPES } from '@white-label-configuration/constants';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { BTicketAdditionalInfo, BTicket } from 'ui-shared-components'
import { User } from '@white-label-types/parking-checkout';
// MIGRATION-TODO: This will be removed when migrating the next feature library

interface ReceiptBookingOrdersProps {
  isParkingProduct?: boolean;
  items: ReceiptItem[];
  orderReference?: string;
  subItems?: ReceiptItem[];
  modifications?: {
    hideAdditionalInfo?: boolean;
    hideDirections?: boolean;
    showPaymentForPrint?: boolean;
  };
  bundleName?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'receipt-booking-orders',
  props: {
    isParkingProduct: { type: Boolean, default: false },
    items: null,
    orderReference: { default: '' },
    subItems: { default: () => [] },
    modifications: { default: () => ({}) },
    bundleName: { default: '' }
  },
  setup(__props: any) {

const props = __props as { isParkingProduct: boolean, items: ReceiptItem[], orderReference: string, subItems: ReceiptItem[], modifications: {
    hideAdditionalInfo?: boolean;
    hideDirections?: boolean;
    showPaymentForPrint?: boolean;
  }, bundleName: string };




const cancellationPolicies: ComputedRef<Policy[]> = computed(() => {
  if (props.items[0]?.cancellation_protection) {
    return props.items[0].cancellation_protection.cancellation_policies;
  }
  return props.items[0]?.inventory_option?.cancellation_policies;
}) ;

const sortedOrderItems: ComputedRef<ReceiptItem[]> = computed(() => {
  const items = [...props.items];

  return items.sort((a, b) => {
    const productCodeA = a.product_code;
    const productCodeB = b.product_code;

    const entryDateA = a.order_criteria?.[productCodeA]?.date1;
    const entryDateB = b.order_criteria?.[productCodeB]?.date1;

    const entryTimeA = a.order_criteria?.[productCodeA]?.time1;
    const entryTimeB = b.order_criteria?.[productCodeB]?.time1;

    const entryDateTimeA = `${entryDateA} ${entryTimeA}`;
    const entryDateTimeB = `${entryDateB} ${entryTimeB}`;

    if (!entryTimeA && !entryTimeB) {
      return productCodeA.localeCompare(productCodeB);
    } else if (!entryTimeA) {
      return 1;
    } else if (!entryTimeB) {
      return -1;
    } else {
      return new Date(entryDateTimeA).getTime() - new Date(entryDateTimeB).getTime();
    }
  })
})

const combinedUser: ComputedRef<User | null> = computed(() => {
      return props.items.reduce((accumulator, currentValue) => {
        if (!accumulator) {
          return { ...currentValue.user };
        }
        const obj = { ...accumulator };
        Object.keys(currentValue.user).forEach((key) => {
          if (key === 'phone' && !obj[key].phoneNumber && currentValue.user[key].phone_number) {
            obj.phone = { ...currentValue.user.phone };
          } else if (!obj[key] && currentValue.user[key]) {
            obj[key] = currentValue.user[key];
          }
        });
        return obj;
      }, null);
    });

const getBTicketProps = (item: ReceiptItem) => {
  return {
    ticketData: item,
    orderReference: props.orderReference,
    subItems: props.subItems,
    showDirections: itemIsParkingProduct(item),
    showPolicies: true,
    isEntryExitProduct: itemIsParkingProduct(item),
    ...(!itemIsParkingProduct(item) && {
      hideLocationInfo: props.modifications?.hideLocationInfo,
      hideAccessSection: props.modifications?.hideAccessSection,
      accessInfoFromEntranceInfo: props.modifications?.accessInfoFromEntranceInfo,
    }),
    collapsible: true,
    bundleName: props.bundleName,
  }
}

const toggleDetailsFn = (isOpen: boolean, item: ReceiptItem) =>{
  if (item.product_code === PRODUCT_TYPES.FASTTRACK) {
    datadogRum.addAction('disclosureCard', {
      value: isOpen ? 'expanded' : 'collapsed'
    });
  }
}


const itemIsParkingProduct = (item: ReceiptItem): boolean => {
  return item.product_code === 'parking';
}

return { __sfc: true,props, cancellationPolicies, sortedOrderItems, combinedUser, getBTicketProps, toggleDetailsFn, itemIsParkingProduct, PortalTarget, BTicketAdditionalInfo, BTicket }
}

})